import React, { useEffect, useRef } from "react";

import * as d3 from "d3";

import { colorBands } from "src/organization/pages/project/environment/metrics/constant";
import { TopImpactValueType } from "src/organization/pages/project/environment/metrics/http2/impact/types";

type LinePropType = {
  index: number;
  data: TopImpactValueType[];
  xScale: d3.ScaleTime<number, number, never>;
  yScale: d3.ScaleLinear<number, number, never>;
};

const Line = (props: LinePropType) => {
  const { data, yScale, xScale, index } = props;
  const urlLineRef = useRef<SVGGElement>(null);

  useEffect(() => {
    const generateLine = d3
      .line<TopImpactValueType>()
      .x(d => xScale(d.date))
      .y(d => {
        return yScale(d.value || 0);
      });
    d3.select(urlLineRef.current)
      .selectAll("path")
      .data([data])
      .join("path")
      .attr("d", generateLine)
      .attr("stroke", colorBands[index])
      .attr("stroke-width", 1.5)
      .attr("fill", "none");
  }, [data, xScale, yScale, index]);

  return <g ref={urlLineRef} />;
};

export default Line;
